import React from "react";

export const unityLoadingOpen = (
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  (window as { [key: string]: any })["loading_on"] = () => {
    setLoading(true);
  };
};
